import React from "react";
import type { DemographicSurveyViewProps } from "@ps-bridge/contracts/demographicSurvey";
import * as styles from "@styles/Demographic.css";

type ZipcodeErrorContractProps = Pick<DemographicSurveyViewProps, never>;

export type ZipcodeErrorViewProps = ZipcodeErrorContractProps & {
  message: string;
};

const ZipcodeErrorView: React.FC<ZipcodeErrorViewProps> = ({ message }) => (
  <p className={styles.errorText}>{message}</p>
);

export default ZipcodeErrorView;
